const ReimbursementLevel = ({ translate, needsLevels = 5, labels = {} }) => {
  const getDefaultLabel = (value) => {
    const defaultLabels = {
      1: translate?.LEVELS?.MINIMUM,
      2: translate?.LEVELS?.PARTIEL,
      3: translate?.LEVELS?.RENFORCE,
      4: translate?.LEVELS?.CONFORT,
      5: translate?.LEVELS?.SUPERIEUR,
    };
    return (
      defaultLabels[value] ||
      `${translate?.LEVELS?.LEVEL_LABEL || "Niveau"} ${value}`
    );
  };

  const levels = Array.from({ length: needsLevels }, (_, i) => {
    const value = i + 1;
    return {
      label: labels[String(value)] || getDefaultLabel(value),
      value,
      description: "",
    };
  });

  return (
    <div className="acoris-levels">
      {levels.map(({ label, value, description }) => (
        <div className="acoris-levels__item" key={value}>
          <div className="acoris-levels__bar">
            <div
              className="acoris-levels__track"
              style={{ width: `${(value / needsLevels) * 100}%` }}
            />
            <div
              className="acoris-levels__circle"
              style={{ left: `${(value / needsLevels) * 100}%` }}
            >
              <div className="acoris-levels__marker">{label}</div>
              <div className="acoris-levels__thumb" />
            </div>
          </div>
          <div className="acoris-levels__description">
            <span>
              {translate?.LEVELS?.LEVEL_LABEL || "Niveau"} {label} :
            </span>
            <p>{description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReimbursementLevel;
